import api from '@/services/api';

import { load, load_close } from '@/services/load';
import { rootAuth_remove } from '@/storages/auth';

// BEFOREEACH
    export function beforeEach(to, form, next){
        load(1);

        response(to, form, next);
    }


    // MIDDLEWARE -> apijs (401 (Unauthorized))
    const response = async (to, form, next) => {
        var request = {};

        // $_GET
            $_GET = {};
            for(let key in to.query){
                $_GET[key] = to.query[key];
            }
        // $_GET


        // LOGOUT
            if(to.params.pg == `login` && to.params.get_1 == `logout`){
                await api(`/login/logout`);
                rootAuth_remove();
            }
        // LOGOUT


        // REQUEST
            let $pg = ``;

            // ?PG=
                if(to.href.split(`?pg=`)[1] != undefined){
                    let $ex = to.href.split(`?pg=`)[1];
                    let $ex_1 = $ex.split(`/`);
                    to.params.pg = $pg = $ex_1[0];
                    if($ex_1?.[1]!=undefined) to.params.get_1 = $ex_1[1];
                    if($ex_1?.[2]!=undefined) to.params.get_1 = $ex_1[2];
                    if($ex_1?.[3]!=undefined) to.params.get_1 = $ex_1[3];
                    if($ex_1?.[4]!=undefined) to.params.get_1 = $ex_1[4];
                }
            // ?PG=

            // HOME
                else if(to.name == `home` || to.params.pg == `index.html` || to.params.pg == `` || to.path == `/index.html`){
                    $pg = `home`;
                    to.params.pg = $pg;
                }
            // HOME

            // OTHER
                else if(to.params.pg) {
                    $pg = to.params.pg;
                }
            // OTHER


            // document.querySelectorAll(`#app2`).forEach(element => {
            //     element.insertAdjacentHTML('beforeend', `<div>${window.location.href}</div>`);
            //     element.insertAdjacentHTML('beforeend', `<div>href = ${to.href}</div>`);
            //     element.insertAdjacentHTML('beforeend', `<div>pg = ${$pg}</div>`);
            //     element.insertAdjacentHTML('beforeend', `<div>name = ${to.name}</div>`);
            //     element.insertAdjacentHTML('beforeend', `<div>params.pg = ${to.params.pg}</div>`);
            //     element.insertAdjacentHTML('beforeend', `<div>params.get_1 = ${to.params.get_1}</div>`);                    
            // });

            if($pg == `error404`){
                $pg = `home`;
            }

            if(!$pg){
                next({ path: '/error404', replace: true })
            } else {
                Object.assign(request, await api(`/${$pg}_index`, to.params));
            }
        // REQUEST


        // NEXT
            // PARAMS REQUEST
                if(request){
                    to.params['request'] = request;
                }
            // PARAMS REQUEST

            next(true);
        // NEXT

    }
// BEFOREEACH


// AFTEREACH
    export function afterEach(to, form){
        load_close();
    }
// AFTEREACH
